<template>
  <div id="viewVideoNew">
    <div class="close" @click="jump('/')">
      <img src="../assets/close.png" alt="">
    </div>
    <div class="player-wrap" id="asvideoPlayer"></div>
    <!-- <video controls ref="video">
      <source :src="videoUrl" type="video/mp4">
        <source :src="videoUrl" type="video/ogg">
        <source :src="videoUrl" type="video/webm">
    </video> -->
    <img src="../assets/xiazai.png" class="xiazai" @click.stop="toxiazai" v-show="isshowxiazai">
    <!-- <img src="/static/img/fenxiang2.png" class="fenxiang" @click.stop="tofenxiang" v-show="isshowfenxiang"> -->
  </div>
</template>

<script>
import {api_video} from "@/components/APIKeys";
import { enums } from "../../../enum";
import Player from 'xgplayer';
import { Toast } from 'vant';
// import tripOrderDetailsVue from '../../../../../yuanzishangcheng_houtai/src/components/page/atoTrip/tripOrderDetails.vue';
export default {
    data(){
        return {
            player: null,
            isshowfenxiang:true,
            isshowxiazai:true,
            videoUrl:"",
            imgurl:"",
            index:"",
        }
    },
    created()
    {
        
    },
    mounted () {
        var userAgent = navigator.userAgent;
        if (userAgent.indexOf("android") > -1) {
            this.isshowfenxiang=true
        } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
            this.isshowfenxiang=true
            // this.isshowxiazai=true
        } else {
            this.isshowfenxiang=false
        }
        // this.isApps();
        this.index = this.$route.query.index;
        this.index == -1 ? this.playDefaultVideo() : this.videoList()
    },
    methods:{
        jump(value)
        {
            this.player.destroy();
            this.$router.push({path:'/'})
        },
        videoList()
        {
            this.$axios.post(api_video).then(res => {
                let videos = res.data.data;
                const index = this.$route.query.index
                const data = videos.data[index]
                // console.log("datadatadatadatadata",data)
                if (data) {
                    const { readVideoUrl, videoUrl480, videoUrl720, videoUrl1080, videoImg, videoTitle } = data
                    this.videoUrl = readVideoUrl
                    this.imgurl = videoImg || ""
                    this.videoTitle = videoTitle || ""
                    this.initVideo(data)
                }

                // if(videos.data[this.$route.query.index] && videos.data)
                // {
                //     this.videoUrl = videos.data[this.$route.query.index].readVideoUrl;
                //     this.$refs.video.src = this.videoUrl;
                //     this.imgurl = videos.data[this.$route.query.index].videoImg;
                //     this.videotitle = videos.data[this.$route.query.index].videoTitle;
                //     this.$refs.video.play();
                // }
            });
        },
        tofenxiang(){
            try {
                let _this=this
                var userAgent = navigator.userAgent;
                if (userAgent.indexOf("android") > -1) {
                    window.Android.shareNewsFromWebsite(_this.videotitle,_this.videoUrl,_this.imgurl);
                } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
                    // let datas=JSON.stringify({fxtitle:_this.videotitle,fxurl:_this.videoUrl,fxcoverimg:_this.imgurl})
                    let datas=JSON.stringify({fxtitle:_this.videotitle,fxurl:window.location.href,fxcoverimg:_this.imgurl})
                    
                    window.webkit.messageHandlers.shareNewsToiPhone.postMessage(datas);
                }
            } catch (error) {
                Toast("此应用暂不支持分享");
            }   
            
        },
        toxiazai(){
            // let _this=this
            // let u = navigator.userAgent;
            // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            // if (isAndroid) 
            // {
            //     try{
            //         window.Android.downloadVideo(_this.videoUrl,_this.videotitle);
            //     }
            //     catch(err)
            //     {
            //         _this.downloadVideo(_this.videoUrl)
            //     }  
            // } 
            // else
            // {
            //     _this.downloadVideo(_this.videoUrl)
            // }
           this.downloadApp(this.videoUrl)
        },
        // downloadVideo(url)
        // {
        //     window.location.href = url;
        // },
        // 下载app 打开外链 
        downloadApp(url){
            let u = navigator.userAgent;
            let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (isAndroid) 
            {
                // console.log("安卓安卓",isAndroid) 
                try{
                    // console.log("安卓安卓") 
                    window.Android.downloadSeaAtoshi(url);
                }
                catch(error){
                    try {
                        downloadSeaAtoshi.postMessage(url)
                    } catch (error) {
                        window.location.href = url;
                    }
                    // console.log("安卓error",error) 
                    // window.location.href = url;
                }
            } 
            else if (isiOS) 
            {
                // console.log("苹果苹果",isiOS)
                try{
                    // console.log("iosiosiosios")
                    window.webkit.messageHandlers.downloadSeaAtoshi.postMessage(url);
                }
                catch(error){
                    try {
                        downloadSeaAtoshi.postMessage(url)
                    } catch (error) {
                        window.location.href = url;
                    }
                    // console.log("苹果error",error)
                    // window.location.href = url;
                }
            } 
            else
            {
                // console.log("安卓安卓else") 
                // console.log("苹果else") 
                window.location.href = url;
            }
        },
        initVideo (data) {
            const { readVideoUrl, videoUrl480, videoUrl720, videoUrl1080, videoImg, videoTitle } = data
            this.player = new Player({
                id: 'asvideoPlayer',
                url: readVideoUrl,
                autoplay: true,
                definitionActive: 'click',
                rotateFullscreen: false,
                cssFullscreen: false,
            });

            const videoList = [
                {
                    name: '流畅',
                    url: readVideoUrl
                },
                {
                    name: '480p',
                    url: videoUrl480
                },
                {
                    name: '720p',
                    url: videoUrl720
                },
                {
                    name: '1080p',
                    url: videoUrl1080
                }
            ]
            // console.log("videoListvideoListvideoListvideoListvideoListvideoList",videoList)

            this.player.emit('resourceReady', videoList);
        },
        playDefaultVideo () {
            let defaultVideo = {
                readVideoUrl: enums.atoscnMp4,
                videoUrl480: enums.atoscnMp4480,
                videoUrl720: enums.atoscnMp4720,
                videoUrl1080: enums.atoscnMp41080,
                videoImg: "",
                videoTitle: ""
            }
            this.initVideo(defaultVideo)
        },
        // // 判断是否是app内
        // isApps()
        // {
        //     let u = navigator.userAgent;
        //     let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        //     let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

        //     if(isAndroid)
        //     {
        //     try{
        //         let isApp = window.Android.isApp();
        //         if(isApp == "android_yuanzilian")
        //         {
        //         this.isshowxiazai = false;
        //         }
        //         else
        //         {
        //         this.isshowxiazai = true;
        //         }
        //     }
        //     catch(error)
        //     {
        //         this.isshowxiazai = true;
        //     }
        //     }
        //     if(isiOS)
        //     {
        //     try{
        //         //1、通知IOS 传参数; isApp ios方法
        //         window.webkit.messageHandlers.isApp.postMessage({})
        //         window.isApp = this.isIosApp;
        //     }
        //     catch(error)
        //     {
        //         this.isshowxiazai = true;
        //     }
        //     }
        // },
        // //获取ios 
        // isIosApp:function(value){
        //     if(value == "ios_yuanzilian")
        //     {
        //         this.isshowxiazai = false;
        //     }
        //     else
        //     {
        //         this.isshowxiazai = true;
        //     }
        // },
    },
    beforeDestroy () {
        this.player.destroy()
    }
};
</script>

<style scoped>
#viewVideoNew {
  width: 100%;
  min-height: 100%;
  /* position: fixed;
  top: 0;
  left: 0;
  bottom: 0; */
  background-color: #000;
  /* z-index: 1002; */
}
.player-wrap {
  width: 100%!important;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
/* video {
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
} */
.close{
  position:absolute;
  right: 0rem;
  top: 0rem;
  width: .8rem;
  height: .8rem;
  z-index: 99999!important;
}
.close img{
  width: 100%;
}
.xiazai{
    width:0.92rem;
    height:0.92rem;
    position: fixed;
    bottom:2rem;
    right:0.19rem;
    z-index:9999!important;
}
.fenxiang{
    width:0.7rem;
    height:0.7rem;
    position: fixed;
    bottom:1.1rem;
    right:0.3rem;
    z-index:1003;
}
</style>
<style>
#viewVideoNew .xgplayer-skin-default .xgplayer-fullscreen, #viewVideoNew .xgplayer-skin-default .xgplayer-fullscreen-img
{
  display: none!important;
}
</style>



// WEBPACK FOOTER //
// src/modules/AtomicChain/pages/videoPlayer.vue